export enum EDropdownTab {
  PREDEFINED,
  OWN,
}
